export type StatusSolicitacaoOrcamento =
  | "NOVO"
  | "EM_ANALISE"
  | "AGUARDANDO_CLIENTE"
  | "PROPOSTA_ENVIADA"
  | "APROVADO"
  | "RECUSADO"
  | "CANCELADO";

export type OrigemSolicitacaoOrcamento = "SITE" | "INTERNO";

export interface IServicoOrcamento {
  id: number;
  nome: string;
  descricao?: string | null;
  ordem: number;
  ativo: boolean;
  exibirSite: boolean;
  precoUnitario: number | string;
  permiteQuantidade: boolean;
  unidadeMedida: string;
  createAt?: string;
  updatedAt?: string;
}

export interface IItemSolicitacaoOrcamento {
  id: number;
  servicoId: number;
  quantidade: number;
  valorUnitario: number | string;
  valorTotal: number | string;
  observacao?: string | null;
  servico?: {
    id: number;
    nome: string;
    unidadeMedida?: string;
    permiteQuantidade?: boolean;
    precoUnitario?: number | string;
  };
}

export interface ISolicitacaoOrcamento {
  id: number;
  codigo: string;
  status: StatusSolicitacaoOrcamento;
  origem?: OrigemSolicitacaoOrcamento;
  nomeOrganizador: string;
  email: string;
  telefone: string;
  cidade: string;
  dataEvento: string;
  numeroAtletas: number;
  largadaChegadaMesmoPonto: boolean;
  modalidadeTexto: string;
  modalidadeId?: number | null;
  distanciaProva: string;
  horaLargada: string;
  observacoes?: string | null;
  obsInterna?: string | null;
  valorProposto?: number | string | null;
  propostaEnviadaEm?: string | null;
  aceiteLgpd: boolean;
  criadoPorId?: string | null;
  responsavelId?: string | null;
  itens?: IItemSolicitacaoOrcamento[];
  valorCalculado?: number;
  createAt?: string;
  updatedAt?: string;
  responsavel?: { id: string; nome: string } | null;
  criadoPor?: { id: string; nome: string; email?: string } | null;
  modalidade?: { id: number; tipo: string } | null;
  historico?: {
    id: number;
    statusAnterior?: StatusSolicitacaoOrcamento | null;
    statusNovo: StatusSolicitacaoOrcamento;
    observacao?: string | null;
    createAt: string;
    usuario?: { id: string; nome: string; email: string } | null;
  }[];
}

export interface ICreateSolicitacaoOrcamentoAdminPayload {
  nomeOrganizador: string;
  email: string;
  telefone: string;
  cidade: string;
  dataEvento: string;
  numeroAtletas: number;
  largadaChegadaMesmoPonto: boolean;
  modalidadeTexto: string;
  modalidadeId?: number | null;
  distanciaProva: string;
  horaLargada: string;
  observacoes?: string | null;
  obsInterna?: string | null;
  aceiteLgpd?: boolean;
  itens: {
    servicoId: number;
    quantidade: number;
    observacao?: string | null;
  }[];
}

export interface IPrecificacaoOrcamento {
  solicitacaoId: number;
  codigo: string;
  valorCalculado: number;
  valorProposto: number | null;
  itens: {
    id: number;
    servicoId: number;
    nome: string;
    unidadeMedida: string;
    permiteQuantidade: boolean;
    quantidade: number;
    valorUnitario: number;
    valorTotal: number;
    precoUnitarioCatalogo: number;
    observacao?: string | null;
  }[];
}

export const STATUS_SOLICITACAO_LABEL: Record<StatusSolicitacaoOrcamento, string> = {
  NOVO: "Novo",
  EM_ANALISE: "Em análise",
  AGUARDANDO_CLIENTE: "Aguardando cliente",
  PROPOSTA_ENVIADA: "Proposta enviada",
  APROVADO: "Aprovado",
  RECUSADO: "Recusado",
  CANCELADO: "Cancelado",
};

export const ORIGEM_SOLICITACAO_LABEL: Record<OrigemSolicitacaoOrcamento, string> = {
  SITE: "Site",
  INTERNO: "Painel",
};
